/**
 * TODO - preamble
 *
 * Empty objects, useful for initializing
 */

import { deepClone } from '../../lib/utils/objects';

import {
    SeniorPersonalInfoViewModel,
    StudentPersonalInfoViewModel,
    TeacherPersonalInfoViewModel,
    ActiveMilitaryPersonalInfoViewModel,
    DocUploadViewModel,
    FieldValidationErrors,
    InactiveMilitaryPersonalInfoViewModel,
    FirstResponderPersonalInfoViewModel,
    MedicalProfessionalPersonalInfoViewModel,
    EmploymentPersonalInfoViewModel,
    ProgramTheme,
    SSOViewModel,
} from './types';
import { getCustomValidatorFields } from '../validators/customValidators';

// TODO use Object.freeze here
export const stuPInfoReqEmpty: StudentPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    countryChoice: undefined,
    localeChoice: undefined,
    metadata: { marketConsentValue: false },
};

// TODO use Object.freeze here
export const seniorPInfoReqEmpty: SeniorPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    postalCode: '',
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

// TODO use Object.freeze here
export const teaPInfoReqEmpty: TeacherPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    organization: {
        id: 0,
        name: '',
    },
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

export const activeMilitaryPInfoReqEmpty: ActiveMilitaryPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

export const inactiveMilitaryPInfoReqEmpty: InactiveMilitaryPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    dischargeDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

export const firstResponderPInfoReqEmpty: FirstResponderPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

export const medicalProfessionalPInfoReqEmpty: MedicalProfessionalPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    postalCode: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};


export const employmentPInfoReqEmpty: EmploymentPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    postalCode: '',
    organization: {
        id: 0,
        name: '',
    },
    address1: '',
    city: '',
    state: '',
    metadata: { marketConsentValue: false },
    localeChoice: undefined,
    countryChoice: undefined,
};

// TODO use Object.freeze here
export const docUploadEmpty: DocUploadViewModel = {
    localeChoice: undefined,
    countryChoice: undefined,
    file1: undefined,
    file2: undefined,
    file3: undefined,
};

export const ssoEmpty: SSOViewModel = {
    localeChoice: undefined,
    isSSOActive: false,
    countryChoice: undefined,
};

const initialErrorStructure = Object.freeze({
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    phoneNumber: undefined,
    birthDate: undefined,
    organization: undefined,
    postalCode: undefined,
    address1: undefined,
    city: undefined,
    state: undefined,
    dischargeDate: undefined,
    docUpload: undefined,
    status: undefined,
    marketConsentValue: undefined,
});

export const getFieldValidationErrorsEmpty = (): FieldValidationErrors => deepClone(initialErrorStructure);

export const getExtendedFieldValidationErrorsEmpty = () => {
    const customValidatorFieldsEmpty = {};
    const customValidatorFields = getCustomValidatorFields();
    if (customValidatorFields) {
        for (const field of customValidatorFields) {
            customValidatorFieldsEmpty[field] = undefined;
        }
    }
    return customValidatorFieldsEmpty;
};

export const GetEmptyTheme = (): ProgramTheme => ({
    intl: {
        locale: 'en-US',
        // @ts-ignore
        messages: {},
    },
    customCss: '',
});
